//
//
//
//
//
//
//
//
//
//
//
//

let timer = null;
export default {
    props: {
        mainWidth: {
            type: [String, Number],
            default: 903
        },
        serviceClick: Function
    },
    data() {
        return {
            media: 0
        }
    },
    mounted() {
        this.checkClientWidth()
        // if(this.$device == 'pc') window.addEventListener('resize', this.checkClientWidth)        
        // window.addEventListener('scroll', this.show)
    },
    beforeDestroy() {
        // if(this.$device == 'pc') window.addEventListener('resize', this.checkClientWidth)
        // window.removeEventListener('scroll', this.show)
    },
    methods: {
        checkClientWidth() {
            let _width = window.innerWidth || Math.max(document.documentElement.clientWidth, document.body.clientWidth)            
            if(_width < this.mainWidth*1 + 70) this.media = 70
            else this.media = 0
        },
        // show() {
        //     if(timer) clearTimeout(timer)
        //     timer = setTimeout(()=>{
        //         let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        //         if(scrollTop > 0) this.hide = false
        //         else this.hide = true
        //     }, 100)
        // },
        handleClick() {
           if (this.serviceClick && typeof this.serviceClick == 'function') {
               this.serviceClick()
           }
        }
    }
}
